export default __webpack_public_path__ + "82736aaa11c64709055f2b7f1c1dcb0f.ttf";